'use strict';

var React = require('react');

var SvgCardReaderMajor = function SvgCardReaderMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5v1.5h-20v-1.5zm0 3.5v7.5a1.5 1.5 0 0 0 1.5 1.5h2.5a6 6 0 0 1 12 0h2.5a1.5 1.5 0 0 0 1.5-1.5v-7.5h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10a4 4 0 0 0-4 4v3h3v2a1 1 0 1 0 2 0v-2h3v-3a4 4 0 0 0-4-4z"
  }));
};

exports.SvgCardReaderMajor = SvgCardReaderMajor;
